// extracted by mini-css-extract-plugin
module.exports = {"practitionerRegisterWrapper":"__practitionerRegisterWrapper___1ZvKz","heading":"__heading___3RB5B","dividerText":"__dividerText___2lbKi"};